import { IBlogPageViewModel } from 'Types/Litium';
import BlogMainItem from 'Pages/Blog/BlogMainItem';

interface BlogMainContentProps {
    horizontalDividerImage: IBlogPageViewModel['pageHeaderImage'];
    horizontalDividerImageMobile: IBlogPageViewModel['horizontalDividerImageMobile'];
    expandMainBlogItemBodyText: IBlogPageViewModel['expandMainBlogItemBodyText'];
    moreBlogItemsWrittenByText: IBlogPageViewModel['moreBlogItemsWrittenByText'];
    writtenByText: IBlogPageViewModel['writtenByText'];
    noBlogItemsFoundText: IBlogPageViewModel['noBlogItemsFoundText'];
    authorLinkBase: IBlogPageViewModel['authorLinkBase'];
    mainBlogItem: IBlogPageViewModel['mainBlogItem'];
    blogItemThumbnailList: IBlogPageViewModel['blogItemThumbnailList'];
}

const BlogMainContent = ({
    horizontalDividerImage,
    horizontalDividerImageMobile,
    expandMainBlogItemBodyText,
    moreBlogItemsWrittenByText,
    writtenByText,
    noBlogItemsFoundText,
    authorLinkBase,
    mainBlogItem,
    blogItemThumbnailList,
}: BlogMainContentProps) => (
    <div className="relative mx-2.5 lg:mx-auto">
        {noBlogItemsFoundText && (
            <div className="mb-4">
                <span>{noBlogItemsFoundText}</span>
            </div>
        )}
        <div className="flex flex-col">
            <div className="mb-5 w-full">
                {mainBlogItem && (
                    <BlogMainItem
                        horizontalDividerImage={horizontalDividerImage}
                        horizontalDividerImageMobile={
                            horizontalDividerImageMobile
                        }
                        expandMainBlogItemBodyText={expandMainBlogItemBodyText}
                        writtenByText={writtenByText}
                        authorLinkBase={authorLinkBase}
                        mainBlogItem={mainBlogItem}
                    />
                )}

                <div className="mt-10">
                    {moreBlogItemsWrittenByText && mainBlogItem.author && (
                        <span className="mb-4 block font-montserrat text-lg font-semibold">
                            {moreBlogItemsWrittenByText}
                            <span className="capitalize">
                                {mainBlogItem.author}
                            </span>
                        </span>
                    )}

                    {blogItemThumbnailList?.length > 0 && (
                        <ul className="grid grid-cols-2 gap-6">
                            {blogItemThumbnailList.map((item, index) => {
                                const extraLargeItem =
                                    index === 0 || index % 3 === 0;
                                return (
                                    <li
                                        key={index}
                                        className={`${
                                            extraLargeItem
                                                ? 'col-span-2 md:col-span-1'
                                                : ''
                                        }`}
                                    >
                                        <a href={item.url}>
                                            <img
                                                className="w-full"
                                                src={item.thumbnailImage.src}
                                                alt={
                                                    item.thumbnailImage.altText
                                                }
                                                width={
                                                    item.thumbnailImage.width >
                                                    0
                                                        ? item.thumbnailImage
                                                              .width
                                                        : ''
                                                }
                                                height={
                                                    item.thumbnailImage.height >
                                                    0
                                                        ? item.thumbnailImage
                                                              .height
                                                        : ''
                                                }
                                            />

                                            <span className="my-1 block font-montserrat text-lg font-semibold leading-5">
                                                {item.thumbnailHeaderText}
                                            </span>

                                            <span className="font-roboto text-sm">
                                                {item.thumbnailDescription}
                                            </span>
                                        </a>
                                    </li>
                                );
                            })}
                        </ul>
                    )}
                </div>
            </div>
        </div>
    </div>
);

export default BlogMainContent;
